import {BLOCK_TYPE_ARTICLE_LIST_ALL} from '@/modules/article/sanity/article-list-all-container/constants';
import {ARTICLE_LIST_ALL_FRAGMENT} from '@/modules/article/sanity/article-list-all-container/query';
import {BLOCK_TYPE_ARTICLE_LIST_LATEST} from '@/modules/article/sanity/article-list-latest-container/constants';
import {ARTICLE_LIST_LATEST_FRAGMENT} from '@/modules/article/sanity/article-list-latest-container/query';
import {BLOCK_TYPE_ARTICLE_LIST_SELECTION} from '@/modules/article/sanity/article-list-selection-container/constants';
import {ARTICLE_LIST_SELECTION_FRAGMENT} from '@/modules/article/sanity/article-list-selection-container/query';
import {BLOCK_TYPE_COMPANIES_LIST_ALL} from '@/modules/finkn/companies/content-blocks/sanity/companies-list-all/constants';
import {COMPANIES_LIST_ALL_FRAGMENT} from '@/modules/finkn/companies/content-blocks/sanity/companies-list-all/query';
import {BLOCK_TYPE_COMPANIES_LIST_LINKS} from '@/modules/finkn/companies/content-blocks/sanity/companies-list-links/constants';
import {COMPANIES_LIST_LINKS_FRAGMENT} from '@/modules/finkn/companies/content-blocks/sanity/companies-list-links/query';
import {BLOCK_TYPE_BANNER} from '@/modules/finkn/content-blocks/sanity/banner/constants';
import {BANNER_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/banner/query';
import {BLOCK_TYPE_CARD_LINK_LIST_SELECTION} from '@/modules/finkn/content-blocks/sanity/card-link-list-selection/constants';
import {CARD_LINK_LIST_SELECTION_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/card-link-list-selection/query';
import {BLOCK_TYPE_COLLAPSIBLE_CONTENT} from '@/modules/finkn/content-blocks/sanity/collapsible-content/constants';
import {COLLAPSIBLE_CONTENT_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/collapsible-content/query';
import {BLOCK_TYPE_COOKIE_LIST} from '@/modules/finkn/content-blocks/sanity/cookie-list/constants';
import {COOKIE_LIST_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/cookie-list/query';
import {BLOCK_TYPE_FACTS_LIST} from '@/modules/finkn/content-blocks/sanity/facts-list/constants';
import {FACTS_LIST_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/facts-list/query';
import {BLOCK_TYPE_GROUP_LINK_LIST_SELECTION} from '@/modules/finkn/content-blocks/sanity/group-link-list-selection/constants';
import {GROUP_LINK_LIST_SELECTION_FRAGMENT} from '@/modules/finkn/content-blocks/sanity/group-link-list-selection/query';
import {BLOCK_TYPE_FAQ_LIST_ALL} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-all/constants';
import {FAQ_LIST_ALL_FRAGMENT} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-all/query';
import {BLOCK_TYPE_FAQ_LIST_AREA} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-area/constants';
import {FAQ_LIST_AREA_FRAGMENT} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-area/query';
import {BLOCK_TYPE_FAQ_LIST_SELECTION} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-selection/constants';
import {FAQ_LIST_SELECTION_FRAGMENT} from '@/modules/finkn/faq/content-blocks/sanity/faq-list-selection/query';
import {BLOCK_TYPE_AREA_LIST_ALL} from '@/modules/finkn/field-of-area/content-blocks/sanity/area-list-all/constants';
import {AREA_LIST_ALL_FRAGMENT} from '@/modules/finkn/field-of-area/content-blocks/sanity/area-list-all/query';
import {BLOCK_TYPE_FIELD_OF_AREA_LIST_ALL} from '@/modules/finkn/field-of-area/content-blocks/sanity/field-of-area-list-all/constants';
import {FIELD_OF_AREA_LIST_ALL_FRAGMENT} from '@/modules/finkn/field-of-area/content-blocks/sanity/field-of-area-list-all/query';
import {BLOCK_TYPE_GUIDEBOOK_LIST_ALL} from '@/modules/finkn/field-of-area/content-blocks/sanity/guidebook-list-all/constants';
import {GUIDEBOOK_LIST_ALL_FRAGMENT} from '@/modules/finkn/field-of-area/content-blocks/sanity/guidebook-list-all/query';
import {BLOCK_TYPE_NEMND_LIST_ALL} from '@/modules/finkn/nemnd/sanity/nemnd-list-all/constants';
import {NEMND_LIST_ALL_FRAGMENT} from '@/modules/finkn/nemnd/sanity/nemnd-list-all/query';
import {BLOCK_TYPE_LINK_LIST_SELECTION} from '@/modules/page/sanity/content-blocks/link-list-selection-container/constants';
import {LINK_LIST_SELECTION_FRAGMENT} from '@/modules/page/sanity/content-blocks/link-list-selection-container/query';
import {BLOCK_TYPE_TEXT} from '@/modules/page/sanity/content-blocks/text-container/constants';
import {TEXT_SECTION_FRAGMENT} from '@/modules/page/sanity/content-blocks/text-container/query';
import {BLOCK_TYPE_TEXT_WITH_IMAGE_SPLIT} from '@/modules/page/sanity/content-blocks/text-with-image-split-container/constants';
import {TEXT_WITH_IMAGE_SPLIT_FRAGMENT} from '@/modules/page/sanity/content-blocks/text-with-image-split-container/query';
import {BLOCK_TYPE_PERSON_LIST_SELECTION} from '@/modules/person/sanity/person-list-selection-container/constants';
import {PERSON_LIST_SELECTION_FRAGMENT} from '@/modules/person/sanity/person-list-selection-container/query';
import type {PageBySlugQueryResult} from '@/sanity/schemas/types';

export const CONTENT_BLOCKS_FRAGMENT = `//groq
	...,

	// Klart foundation
	_type == "${BLOCK_TYPE_TEXT}" => {
		${TEXT_SECTION_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_TEXT_WITH_IMAGE_SPLIT}" => {
		${TEXT_WITH_IMAGE_SPLIT_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_LINK_LIST_SELECTION}" => {
		${LINK_LIST_SELECTION_FRAGMENT}
	},

	// Article extension
	_type == "${BLOCK_TYPE_ARTICLE_LIST_SELECTION}" => {
		${ARTICLE_LIST_SELECTION_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_ARTICLE_LIST_ALL}" => {
		${ARTICLE_LIST_ALL_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_ARTICLE_LIST_LATEST}" => {
		${ARTICLE_LIST_LATEST_FRAGMENT}
	},

	// Person extension
	_type == "${BLOCK_TYPE_PERSON_LIST_SELECTION}" => {
		${PERSON_LIST_SELECTION_FRAGMENT}
	},

	// Field of area
	_type == "${BLOCK_TYPE_FIELD_OF_AREA_LIST_ALL}" => {
		${FIELD_OF_AREA_LIST_ALL_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_GUIDEBOOK_LIST_ALL}" => {
		${GUIDEBOOK_LIST_ALL_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_AREA_LIST_ALL}" => {
		${AREA_LIST_ALL_FRAGMENT}
	},

	// FAQ
	_type == "${BLOCK_TYPE_FAQ_LIST_ALL}" => {
		${FAQ_LIST_ALL_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_FAQ_LIST_SELECTION}" => {
		${FAQ_LIST_SELECTION_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_FAQ_LIST_AREA}" => {
		${FAQ_LIST_AREA_FRAGMENT}
	},

	// Nemnd
	_type == "${BLOCK_TYPE_NEMND_LIST_ALL}" => {
		${NEMND_LIST_ALL_FRAGMENT}
	},

	// Collapsible content
	_type == "${BLOCK_TYPE_COLLAPSIBLE_CONTENT}" => {
		${COLLAPSIBLE_CONTENT_FRAGMENT}
	},

	// Card link list selection
	_type == "${BLOCK_TYPE_CARD_LINK_LIST_SELECTION}" => {
		${CARD_LINK_LIST_SELECTION_FRAGMENT}
	},

	// Group link list selection
	_type == "${BLOCK_TYPE_GROUP_LINK_LIST_SELECTION}" => {
		${GROUP_LINK_LIST_SELECTION_FRAGMENT}
	},

	// Banner
	_type == "${BLOCK_TYPE_BANNER}" => {
		${BANNER_FRAGMENT}
	},

	// Facts list
	_type == "${BLOCK_TYPE_FACTS_LIST}" => {
		${FACTS_LIST_FRAGMENT}
	},

	// Companies
	_type == "${BLOCK_TYPE_COMPANIES_LIST_ALL}" => {
		${COMPANIES_LIST_ALL_FRAGMENT}
	},
	_type == "${BLOCK_TYPE_COMPANIES_LIST_LINKS}" => {
		${COMPANIES_LIST_LINKS_FRAGMENT}
	},

	// Cookies
	_type == "${BLOCK_TYPE_COOKIE_LIST}" => {
		${COOKIE_LIST_FRAGMENT}
	}
`;

export type ContentBlocksFragment = NonNullable<NonNullable<PageBySlugQueryResult>['content']>;
